(function ($) {

	if ($('.ew-section-business').length) {

		// Scroll to top
		$(window).scroll(function () {
			var scroll = $(window).scrollTop();
			if (scroll >= 500) {
				$(".mobile-contact").addClass("js-slidein-visible");
			}
		});

		// Smooth scrolling to all links
		$("a:not(.nav-link)").on('click', function (event) {
			if (this.hash !== "") {
				event.preventDefault();
				var hash = this.hash;
				$('html, body, .modal-content').animate({
					scrollTop: $(hash).offset().top
				}, 800, function () {
					window.location.hash = hash;
				});
			}
		});
		if ($('.ew-page-venue-training-academy').length) {
			$(".btn-workshop").click(function () {
				var contact = $("#contact");
				contact.addClass("highlighted");
			});
			$(".read-more-btn").click(function () {
				var container = $(this).closest(".read-more-container");
				container.toggleClass("expanded");
				$(this).text(container.hasClass("expanded") ? "read less" : "read more");
			});
			$(".packageInclusionsButton").click(function () {
				$(".package-inclusions-container").toggleClass("expanded");
				$(".packageInclusionsButton").text(
					$(".package-inclusions-container").first().hasClass("expanded") ? "- Hide Inclusions" : "+ View Inclusions"
				);
			});
			
		}
		if ($('.ew-page-amplify').length) {
			$(".read-more-btn").click(function () {
				var container = $(this).closest(".read-more-container");
				container.toggleClass("expanded");
				$(this).text(container.hasClass("expanded") ? "read less" : "read more");
			});
			var reviewSlider = $('#reviewSlider').lightSlider({
                auto: false,
                loop: true,
                speed: 400,
                pager: false,
                controls: false,
                slideMargin: 60,
                item: 2.5,
                responsive: [
                    {
                        breakpoint:992,
                        settings: {
                            item: 2,
                            slideMove: 1,
							slideMargin: 30,
                        }
                    },
                    {
                        breakpoint:480,
                        settings: {
                            item:1,
							slideMargin: 30,
                        }
                    }
                ],
                onSliderLoad: function (el) {
                    // This makes the carousel only load after the deferred JS has loaded (after user scroll/interaction)
                    $('.lSSlideOuter').css('opacity', 1);
                }
            });

            $('#reviewPrevSlide').on('click', function () {
                reviewSlider.goToPrevSlide();
            });

            $('#reviewNextSlide').on('click', function () {
                reviewSlider.goToNextSlide();
            });
		}

		// Business - Home Page
		if ($('.ew-page-business').length) {
			var mediaSlider = $('#mediaSlider').lightSlider({
				auto: true,
				loop: true,
				item: 6,
				slideMove: 1,
				pauseOnHover: true,
				keyPress: true,
				pager: false,
				controls: false,
				speed: 1000,
				pause: 2000,
				responsive: [{
						breakpoint: 1024,
						settings: {
							item: 4
						},
						breakpoint: 576,
						settings: {
							item: 3						
						}
					}
				],
				onSliderLoad: function (el) {
					// This makes the carousel only load after the deferred JS has loaded (after user scroll/interaction)
					$('.lSSlideOuter').css('opacity', 1);
				}
			});
			$('#mediaPrevSlide').on('click', function () {
				mediaSlider.goToPrevSlide();
			});
			
			$('#mediaNextSlide').on('click', function () {
				mediaSlider.goToNextSlide();
			});		
		}

		// Business - Press Page
		if ($('.ew-page-press-media').length) {
			$(".video-slider").lightSlider({
				auto: true,
				loop: true,
				item: 2,
				slideMove: 1,
				pauseOnHover: true,
				keyPress: true,
				pager: false,
				speed: 1000,
				pause: 5000,
				responsive: [{
					breakpoint: 480,
					settings: {
						item: 1,
						slideMove: 1
					}
				}],
				onSliderLoad: function (el) {
					// This makes the carousel only load after the deferred JS has loaded (after user scroll/interaction)
					$('.lSSlideOuter').css('opacity', 1);
				}
				
			});

			$("#media-slider").lightSlider({
				auto: true,
				loop: true,
				item: 6,
				slideMove: 1,
				pauseOnHover: true,
				keyPress: true,
				pager: false,
				speed: 1000,
				pause: 2000,
				responsive: [{
						breakpoint: 1024,
						settings: {
							item: 2,
							slideMove: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							item: 1,
							slideMove: 1
						}
					}
				],
				onSliderLoad: function (el) {
					// This makes the carousel only load after the deferred JS has loaded (after user scroll/interaction)
					$('.lSSlideOuter').css('opacity', 1);
				}
			});

			// Load more articles on Press page
			$(".press-card").slice(0, 4).show();
			$("#loadMore").on('click', function (e) {
				e.preventDefault();
				$(".press-card:hidden").slice(0, 4).slideDown();
				if ($(".press-card:hidden").length == 0) {
					$("#load").fadeOut('slow');
				}
			});
		}

		// AU - Business B2B Referral Page
		if ($('.ew-page-referral').length) {
			// Referral Form - Track the multiple steps with 'active' numbered steps in the form
			if ($('.referral-form').length) {
				var prev_form_step = $('.cf7mls_current_fs').attr('data-cf7mls-order');
				var form_step = $('.cf7mls_current_fs').attr('data-cf7mls-order');
				var prev_form_step_num = parseInt(prev_form_step);
				var form_step_num = parseInt(form_step);
				var interval_check = setInterval(checkCurrentStep, 1000);

				function updateCurrentStep(form_step) {
					prev_form_step_num = parseInt(prev_form_step) + 1;
					form_step_num = parseInt(form_step) + 1;

					prev_form_step = prev_form_step_num.toString();
					form_step = form_step_num.toString();

					$('.referral-form #form-step-' + form_step).addClass('step-active');
					$('.referral-form #form-step-' + prev_form_step).removeClass('step-active');
					form_step = $('.cf7mls_current_fs').attr('data-cf7mls-order');
					prev_form_step = $('.cf7mls_current_fs').attr('data-cf7mls-order');
				}

				function checkCurrentStep() {
					form_step = $('.cf7mls_current_fs').attr('data-cf7mls-order');
					if (form_step !== prev_form_step) {
						updateCurrentStep(form_step);
					}
				}
			}
		}

	}

})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
	const slider = document.getElementById("reviewSlider");
	const slides = Array.from(slider.querySelectorAll("li"));
	const prevBtn = document.getElementById("reviewSliderPrevSlide");
	const nextBtn = document.getElementById("reviewSliderNextSlide");

	let currentIndex = 0;
	let slidesToShow = 6;
	let slideWidth = 0;
	const slideGap = 30;

	function getSlidesToShow() {
		const width = window.innerWidth;
		if (width > 992) return 2.3;
		if (width > 767) return 2;
		return 1.2;
	}

	function updateSliderDimensions() {
		slidesToShow = getSlidesToShow();

		// Subtract total gaps from container width before dividing
		const totalGap = (slidesToShow - 1) * slideGap;
		const containerWidth = slider.parentElement.offsetWidth;
		slideWidth = (containerWidth - totalGap) / slidesToShow;

		slides.forEach((slide, index) => {
			slide.style.width = `${slideWidth}px`;
			slide.style.marginRight = index !== slides.length - 1 ? `${slideGap}px` : "0";
		});

		updateSlidePosition();
	}

	function updateSlidePosition() {
		const maxIndex = Math.ceil(slides.length - slidesToShow);
		currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

		const offset = (slideWidth + slideGap) * currentIndex;
		slider.style.transform = `translateX(-${offset}px)`;

		prevBtn.classList.toggle("disabled", currentIndex <= 0);
		nextBtn.classList.toggle("disabled", currentIndex >= maxIndex);
	}

	prevBtn.addEventListener("click", () => {
		if (!prevBtn.classList.contains("disabled")) {
			currentIndex--;
			updateSlidePosition();
		}
	});

	nextBtn.addEventListener("click", () => {
		if (!nextBtn.classList.contains("disabled")) {
			currentIndex++;
			updateSlidePosition();
		}
	});

	window.addEventListener("resize", () => {
		updateSliderDimensions();
	});

	updateSliderDimensions();

	function checkContactPosition() {
		const contact = document.getElementById('contact');
		const footer = document.querySelector('.sticky-footer');
		
		if (!contact || !footer) return;

		const contactTop = contact.getBoundingClientRect().top;

		if (contactTop <= 0) {
		footer.style.display = 'none';
		} else {
		footer.style.display = '';
		}
	}

	// Listen for scroll events
	window.addEventListener('scroll', checkContactPosition);
	window.addEventListener('resize', checkContactPosition);

	// Run once on load
	window.addEventListener('DOMContentLoaded', checkContactPosition);
});


document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("businessLogoSlider");
  const logos = Array.from(slider.children);

  logos.forEach((logo) => {
    const clone = logo.cloneNode(true);
    slider.appendChild(clone);
  });
});